import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  mark: {
    display: 'block',
    height: 34,
    width: 25,
    objectFit: 'contain',
  },
});

export const LogoIcon = () => {
  const classes = useStyles();

  return (
    <img
      className={classes.mark}
      src="/brand/think-mark-purple.png"
      alt="THiNK Engineering"
    />
  );
};
